var currentScrollPosition = window.pageYOffset,
    mainBody = document.getElementById('main-body'),
    minScrollPosition,
    minScrollBackPosition;

if (document.getElementsByClassName('global-header-banner').length > 0  ) {
    minScrollPosition = 400;
    minScrollBackPosition = 330;
} else {
    minScrollPosition = 200;
    minScrollBackPosition = 79;
}

export function scrollCheck() {
    window.addEventListener('scroll', scrollEvent);
}


function scrollEvent(e) {
    if (mainBody === null || mainBody === undefined)
        return;

    var scrollPosition = window.pageYOffset;

    if (currentScrollPosition > scrollPosition && scrollPosition > minScrollPosition) {
        mainBody.setAttribute('data-scroll', 'scroll-up');
    } else if (currentScrollPosition < scrollPosition && scrollPosition > minScrollPosition) {
        mainBody.setAttribute('data-scroll', 'scroll-down');
    } else if (scrollPosition < minScrollBackPosition){
        mainBody.removeAttribute('data-scroll');
    }  
    currentScrollPosition = scrollPosition;
}



